export let hres33uColumns = () => {
  let indexColumns = [{
    key: 'desc_typ',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '60',
    style: 'min-width: 150px;'
  }, {
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES33UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }]

  let tab2Tab6TableColumns = [{
    key: 'coddeduct',
    name: '',
    labelCodapp: 'HRES33UC9',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_coddeduct',
    name: '',
    labelCodapp: 'HRES33UC9',
    labelIndex: '50',
    style: 'min-width: 300px;'
  }, {
    key: 'amtdeduct',
    name: '',
    labelCodapp: 'HRES33UC9',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }]

  let tab2Tab7TableColumns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codtydoc',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'namdoc',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'numdoc',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'filename',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '60',
    tagType: 'file',
    style: 'min-width: 200px;'
  }, {
    key: 'dterecv',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtedocen',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desnote',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }, {
    key: 'file_status',
    name: '',
    labelCodapp: 'HRES33UC15',
    labelIndex: '140',
    style: 'min-width: 200px;'
  }]

  let tab3Table1Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'level_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '60',
    style: 'min-width: 150px;'
  }, {
    key: 'degree_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'major_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'subject_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'inst_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'country_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '110',
    style: 'min-width: 150px;'
  }, {
    key: 'numgpa_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'stayear_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'dtegyear_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'year'
  }, {
    key: 'flgeduc_n',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '150',
    style: 'min-width: 200px;'
  }]

  let tab3Table2Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'level_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '60',
    style: 'min-width: 150px;'
  }, {
    key: 'degree_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'major_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'subject_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'inst_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'country_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '110',
    style: 'min-width: 150px;'
  }, {
    key: 'numgpa_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'stayear_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'dtegyear_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'year'
  }, {
    key: 'flgeduc_o',
    name: '',
    labelCodapp: 'HRES33UC11',
    labelIndex: '150',
    style: 'min-width: 200px;'
  }]

  let tab4Table1Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'namchild',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'dtechbd',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codsex',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codeduc',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }]

  let tab4Table2Columns = [{
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'namchild',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'dtechbd',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codsex',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codeduc',
    name: '',
    labelCodapp: 'HRES33UC12',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }]

  let tab6Table1Columns = [{
    key: 'destrain_n',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '10',
    style: 'min-width: 150px;'
  }, {
    key: 'dtetrain_n',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtetren_n',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'displace_n',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '40',
    style: 'min-width: 150px;'
  }, {
    key: 'desinstu_n',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '50',
    style: 'min-width: 150px;'
  }]

  let tab6Table2Columns = [{
    key: 'destrain_o',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '10',
    style: 'min-width: 150px;'
  }, {
    key: 'dtetrain_o',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtetren_o',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'displace_o',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '40',
    style: 'min-width: 150px;'
  }, {
    key: 'desinstu_o',
    name: '',
    labelCodapp: 'HRES33UC14',
    labelIndex: '50',
    style: 'min-width: 150px;'
  }]

  return {
    en: {
      index: indexColumns,
      tab2Tab6Table: tab2Tab6TableColumns,
      tab2Tab7Table: tab2Tab7TableColumns,
      tab3Table1: tab3Table1Columns,
      tab3Table2: tab3Table2Columns,
      tab4Table1: tab4Table1Columns,
      tab4Table2: tab4Table2Columns,
      tab6Table1: tab6Table1Columns,
      tab6Table2: tab6Table2Columns
    },
    th: {
      index: indexColumns,
      tab2Tab6Table: tab2Tab6TableColumns,
      tab2Tab7Table: tab2Tab7TableColumns,
      tab3Table1: tab3Table1Columns,
      tab3Table2: tab3Table2Columns,
      tab4Table1: tab4Table1Columns,
      tab4Table2: tab4Table2Columns,
      tab6Table1: tab6Table1Columns,
      tab6Table2: tab6Table2Columns
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/columns/hres33u.js